import React from 'react';

export const ArrowLeft = ({ className = '' }) => (
  <svg
    className={className}
    width="21"
    height="38"
    viewBox="0 0 21 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5384 37.0154C18.8369 37.0109 19.1273 36.9174 19.3723 36.7468C19.6174 36.5763 19.806 36.3366 19.914 36.0582C20.022 35.7799 20.0445 35.4757 19.9787 35.1845C19.9128 34.8933 19.7615 34.6284 19.5442 34.4237L3.65363 18.9998L19.5443 3.576C19.6888 3.43954 19.8048 3.27573 19.8854 3.09406C19.9661 2.9124 20.0099 2.71651 20.0142 2.51779C20.0185 2.31907 19.9833 2.12146 19.9106 1.93647C19.8379 1.75147 19.7292 1.58276 19.5907 1.44015C19.4522 1.29755 19.2868 1.18388 19.104 1.10576C18.9212 1.02763 18.7248 0.986614 18.526 0.985077C18.3272 0.983539 18.1301 1.02152 17.9462 1.09681C17.7622 1.1721 17.5951 1.2832 17.4544 1.42365L0.454407 17.9237C0.310432 18.0635 0.195974 18.2308 0.117817 18.4156C0.0396592 18.6005 -0.000610666 18.7991 -0.000610684 18.9998C-0.000610701 19.2005 0.0396591 19.3992 0.117817 19.584C0.195974 19.7689 0.310432 19.9362 0.454406 20.076L17.4544 36.576C17.5964 36.7181 17.7656 36.8302 17.9518 36.9057C18.138 36.9812 18.3375 37.0185 18.5384 37.0154Z"
      fill="currentColor"
    />
  </svg>
);
